"use client";

import React from "react";
import { AllShips } from "@/interfaces/IShips";
import ShipsByLines from "./ship/ShipsByLines";
import { ICruisesOperators } from "@/interfaces/ICruisesOperators";
import ErrorHandle from "../common/ErrorHandle";
import { PaymentIconsHeaderMobile } from "../common/PaymentHeader";
import { DestinationHero } from "../destinations/DestinationHero";

const ShipLayout: React.FC<{
  allShips: AllShips;
  operators: ICruisesOperators;
  shipRef: string;
  pageNotFound: boolean;
}> = ({ allShips, operators, shipRef, pageNotFound }) => {
  return !pageNotFound ? (
    <div>
      <DestinationHero
        titletop="Ever Wonder"
        title="What the BEST Cruise Ships Are Like? Let's Explore!"
        image={`images/ship/all-ship.webp`}
      />
      <PaymentIconsHeaderMobile sx={{ mt: "6px" }} />
      <ShipsByLines allShips={allShips} operators={operators} shipRef={shipRef} />
    </div>
  ) : (
    <ErrorHandle />
  );
};

export default ShipLayout;
